import React, { useState } from "react";
import "../components/componentstyle/faqBrandSection.css";
import brandImg from "../assets/faqbrand-img.jpg"; // Replace with your actual image path
import { IoCaretDown, IoRemove } from "react-icons/io5";
// Removed import of PiLineVerticalBold from react-icons/pi

const faqData = [
  {
    question: "Are you a processor or trader?",
    answer:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent nisl lorem, dictum id pellentesque at, vestibulum ut arcu. Curabitur erat libero, egestas eu tincidunt ac, rutrum ac justo. Vivamus condimentum laoreet lectus, blandit posuere tortor aliquam vitae. Curabitur molestie eros.",
  },
  {
    question: "In which countries do you supply rice?",
    answer:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent nisl lorem, dictum id pellentesque at, vestibulum ut arcu. Curabitur erat libero, egestas eu tincidunt ac, rutrum ac justo. Vivamus condimentum laoreet lectus, blandit posuere tortor aliquam vitae. Curabitur molestie eros.",
  },
  {
    question: "Where do you purchase the rice from?",
    answer:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent nisl lorem, dictum id pellentesque at, vestibulum ut arcu. Curabitur erat libero, egestas eu tincidunt ac, rutrum ac justo. Vivamus condimentum laoreet lectus, blandit posuere tortor aliquam vitae. Curabitur molestie eros.",
  },
];

const FaqBrandSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? -1 : index);
  };
  return (
    <div className="faq-brand-section">
      <div className="container faqBrand">
        <div className="faq-column">
          <h2>
            <span className="highlight-box">F. A.</span> Question
          </h2>
          <div className="faq-box">
            {/* {faqData.map((item, index) => (
              <div key={index} className="faq-item">
                <div
                  className="faq-question"
                  onClick={() => toggleAccordion(index)}
                >
                  {item.question}
                </div>
                {activeIndex === index && item.answer && (
                  <div className="faq-answer-wrapper">
                    <IoCaretDown className="faq-caret" />
                    <PiLineVerticalBold className="faq-vertical-line" />
                    <div className="faq-answer">{item.answer}</div>
                  </div>
                )}
              </div>
            ))} */}
            {faqData.map((item, index) => (
              <div key={index} className="faq-item">
                <div
                  className="faq-question"
                  onClick={() => toggleAccordion(index)}
                >
                  {item.question}
                </div>
                <div
                  className={`faq-answer-wrapper ${
                    activeIndex === index ? "active" : ""
                  }`}
                >
                  {activeIndex === index && (
                    <>
                      <IoCaretDown className="faq-caret" />
                      <IoRemove className="faq-vertical-line" />
                      <div className="faq-answer">{item.answer}</div>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="brand-column">
          <h2>
            <span className="highlight-box">Our</span> Brand
          </h2>
          <div className="brand-image-container">
            <img src={brandImg} alt="brand" />
            <div className="overlay-text">
              "We have a well-established brand by which we sell our imported
              commodities in the marketplace in India."
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqBrandSection;
